export const GA_MEASUREMENT_ID = 'G-W7PFGBYS4S'; // Replace with your GA4 measurement ID